<template>
  <v-row>
    <v-col>
      <v-alert
        :icon="mdiAlertOutline"
        outlined
        dismissible
        :type="type"
        v-if="type == 'error'"
        class="mb-0 dismissible"
        @input="toggleAlert"
      >
        {{ message }}
      </v-alert>
      <v-alert
        :icon="mdiCheckboxMarkedCircleOutline"
        outlined
        dismissible
        :type="type"
        v-else-if="type == 'success'"
        class="mb-0 dismissible"
        @input="toggleAlert"
      >
        {{ message }}
      </v-alert>
      <v-alert
        :icon="mdiAlertCircle"
        dense
        outlined
        :type="type"
        v-else-if="type == 'warning'"
        class="mb-0"
        @input="toggleAlert"
      >
        {{ message }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mdiAlertOutline } from '@mdi/js';
import { mdiAlertCircle } from '@mdi/js';
import { mdiCheckboxMarkedCircleOutline } from '@mdi/js';

export default {
  data() {
    return {
      mdiAlertOutline,
      mdiAlertCircle,
      mdiCheckboxMarkedCircleOutline,
    };
  },
  props: ['type', 'message'],
  methods: {
    toggleAlert() {
      this.$emit('toggleAlert');
    },
  },
};
</script>
